import createIcon from "components/elements/Icons/create-icon";

export default createIcon("Logout", [
  [
    "path",
    {
      d: "M3.93935 3.93933L3.93933 3.93935C3.65804 4.22065 3.5 4.60217 3.5 5V19C3.5 19.3978 3.65802 19.7794 3.93936 20.0607L4.29178 19.7082L3.93937 20.0607C4.22063 20.3419 4.60212 20.5 5 20.5H9C9.27614 20.5 9.5 20.7238 9.5 21C9.5 21.2762 9.27614 21.5 9 21.5H5C4.33697 21.5 3.70108 21.2366 3.23223 20.7677C2.76339 20.2989 2.5 19.6631 2.5 19V5C2.5 4.33696 2.76339 3.70108 3.23223 3.23223C3.70108 2.76339 4.33696 2.5 5 2.5H9C9.27614 2.5 9.5 2.72386 9.5 3C9.5 3.27614 9.27614 3.5 9 3.5H5C4.60217 3.5 4.22065 3.65804 3.93935 3.93933Z",
    },
  ],
  [
    "path",
    {
      d: "M16.3536 6.64644L16.3535 6.64643C16.1583 6.45119 15.8417 6.45119 15.6465 6.64643L16.3536 6.64644ZM16.3536 6.64644L21.3536 11.6465C21.5488 11.8417 21.5488 12.1583 21.3536 12.3535L16.3536 17.3535C16.1583 17.5488 15.8417 17.5488 15.6465 17.3535C15.4512 17.1583 15.4512 16.8417 15.6465 16.6465L19.9394 12.3536L20.2929 12M16.3536 6.64644L20.2929 12M20.2929 12L19.9394 11.6464M20.2929 12L19.9394 11.6464M19.9394 11.6464L15.6465 7.35357M19.9394 11.6464L15.6465 7.35357M15.6465 7.35357C15.6465 7.35357 15.6465 7.35356 15.6465 7.35356M15.6465 7.35357L15.6465 7.35356M15.6465 7.35356C15.4512 7.15829 15.4512 6.8417 15.6465 6.64643L15.6465 7.35356Z",
    },
  ],
  [
    "path",
    {
      d: "M8.5 12C8.5 11.7238 8.72386 11.5 9 11.5H21C21.2762 11.5 21.5 11.7238 21.5 12C21.5 12.2762 21.2762 12.5 21 12.5H9C8.72386 12.5 8.5 12.2762 8.5 12Z",
    },
  ],
]);
